import axios from 'axios';

const baseURL = '/public/api';

export const getPublicSiteApi = () => {
  const url = `${baseURL}/landing/fetch/api`;
  return axios.get(url);
};
